<template>
  <main v-if="isVisible" class="font-['AlibabaPuHuiTi-Regular','GwbFont','PingFang_SC',sans-serif] text-[#851A00]">
    <div class="relative mx-auto min-h-[100dvh] w-full max-w-[430px]">
      <section
        class="absolute left-1/2 flex w-[318px] -translate-x-1/2 flex-col items-center gap-[8px]"
        :class="isNativeModalView ? 'top-[40px]' : 'top-[186px]'"
        aria-label="获得优惠券"
      >
        <div class="w-full">
          <div class="relative h-[80px] w-full overflow-visible">
            <div
              class="absolute left-0 top-[19px] h-[61px] w-full rounded-t-[20px] bg-[#FFFAEF]"
              aria-hidden="true"
            ></div>
            <span
              class="absolute left-[129px] top-[67px] h-[6px] w-[59px] rounded-full bg-[#FD9F8C] blur-[4px]"
              aria-hidden="true"
            ></span>
            <img
              :src="couponReceivedGift"
              alt=""
              class="absolute left-1/2 top-0 h-[73px] w-[99px] -translate-x-1/2 object-fill"
            />
          </div>

          <div
            class="box-border flex w-full flex-col items-center gap-[12px] rounded-b-[20px] bg-[linear-gradient(180deg,#FFFAEE_0%,#FFFFFF_100%)] px-[16px] py-[12px]"
          >
            <h1 class="m-0 flex w-full items-center justify-center whitespace-nowrap font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont',sans-serif] text-[16px] font-medium leading-[22px] text-[#851A00]">
              <span>恭喜您获得</span><span class="font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont',sans-serif] text-[#FF6B3F]">{{ couponCountText }}</span><span>优惠券</span>
            </h1>

            <div class="flex w-[318px] flex-col items-center gap-[20px]">
              <div
                v-if="receivedCoupons.length"
                class="box-border flex w-full flex-col gap-[12px] px-[16px]"
                :class="couponListClass"
              >
                <article
                  v-for="coupon in receivedCoupons"
                  :key="coupon.id"
                  class="relative h-[73px] w-[287px] shrink-0 overflow-hidden"
                >
                  <img :src="couponReceivedCard" alt="" class="absolute inset-0 h-full w-full" />

                  <div class="absolute left-[15px] top-[11px] flex w-[58px] flex-col items-center gap-[4px]">
                    <div class="flex h-[28px] w-full items-baseline justify-center whitespace-nowrap font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont',sans-serif] font-[800] leading-[28px] text-[#FF6B3F]">
                      <template v-if="coupon.type === 'discount'">
                        <span class="text-[24px] leading-[28px]">{{ coupon.displayValue }}</span>
                        <span class="ml-[1px] text-[16px] font-medium leading-[28px]">折</span>
                      </template>
                      <template v-else>
                        <span class="text-[16px] font-medium leading-[28px]">¥</span>
                        <span class="w-[5px] text-[20px] leading-[28px]" aria-hidden="true"></span>
                        <span class="text-[24px] leading-[28px]">{{ coupon.displayValue }}</span>
                      </template>
                    </div>
                    <div class="box-border flex h-[20px] items-center justify-center whitespace-nowrap rounded-[21px] border border-[rgba(133,26,0,0.06)] px-[10px] text-center">
                      <span class="font-['AlibabaPuHuiTi-Regular','GwbFont',sans-serif] text-[10px] font-normal leading-[14px] text-[#851A00]">{{ coupon.thresholdText }}</span>
                    </div>
                  </div>

                  <div class="absolute left-[114px] top-[9px] flex w-[103px] flex-col gap-[4px]">
                    <div class="flex flex-col gap-[2px]">
                      <h2 class="m-0 max-w-[103px] overflow-hidden text-ellipsis whitespace-nowrap font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular','GwbFont',sans-serif] text-[13px] font-medium leading-[18px] text-white">
                        {{ coupon.name }}
                      </h2>
                      <p class="m-0 max-w-[103px] overflow-hidden text-ellipsis whitespace-nowrap text-[12px] font-normal leading-[17px] text-white/90">
                        {{ coupon.scopeText }}
                      </p>
                    </div>
                    <div class="flex h-[14px] min-w-0 items-center gap-[4px] text-white/90">
                      <ClockIcon class="h-[12px] w-[12px] shrink-0" aria-hidden="true" />
                      <span class="min-w-0 truncate text-[10px] font-normal leading-[14px]">
                        {{ coupon.validText }}
                      </span>
                    </div>
                  </div>
                </article>
              </div>
              <p
                v-else
                class="m-0 flex h-[73px] w-[287px] items-center justify-center rounded-[12px] bg-white/70 text-center font-['AlibabaPuHuiTi-Regular','GwbFont',sans-serif] text-[12px] font-normal leading-[17px] text-[rgba(133,26,0,0.6)]"
              >
                暂无可展示优惠券
              </p>

              <button
                type="button"
                class="h-[54px] w-[225px] cursor-pointer border-0 bg-transparent p-0 active:scale-[0.98]"
                aria-label="前往查看优惠券"
                @click="goMyCoupon"
              >
                <img :src="couponReceivedViewButton" alt="" class="block h-full w-full object-fill" />
              </button>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="flex h-[34px] w-[34px] items-center justify-center border-0 bg-transparent p-0"
          aria-label="关闭"
          @click="closePage"
        >
          <img :src="couponReceivedClose" alt="" class="block h-[34px] w-[34px]" />
        </button>
      </section>
    </div>
  </main>
</template>

<script setup>
import { computed, h, nextTick, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { reportEvent } from '@/utils/auth'
import { getCouponPopup, hasCouponPopupLogin } from '@/api/coupon'
import couponReceivedGift from '@/assets/images/couponReceived/coupon-received-gift-589c00.png'
import couponReceivedCard from '@/assets/images/couponReceived/coupon-received-card.svg'
import couponReceivedViewButton from '@/assets/images/couponReceived/coupon-received-view-button.png'
import couponReceivedClose from '@/assets/images/couponReceived/coupon-received-close.svg'

defineOptions({ name: 'CouponReceivedMobile' })

const router = useRouter()
const route = useRoute()
const COUPON_POPUP_CACHE_PREFIX = 'ydppt_coupon_received_popup_'
const COUPON_POPUP_CACHE_TTL = 60 * 1000

const props = defineProps({
  coupons: {
    type: Array,
    default: () => []
  },
  autoShow: {
    type: Boolean,
    default: true
  },
  modalMode: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'view'])

const isVisible = ref(false)
const apiCoupons = ref([])
const isLoadingCoupons = ref(false)
const latestRequestKey = ref(0)

const sourceCoupons = computed(() => props.coupons?.length ? props.coupons : apiCoupons.value)
const isNativeModalView = computed(() => route.query?.nativeModal === '1')

const normalizeDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return value
  const normalized = String(value).trim().replace(/\./g, '-')
  const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (match) {
    const [, year, month, day] = match
    return new Date(Number(year), Number(month) - 1, Number(day))
  }
  return new Date(value)
}

const formatDate = (value, withYear = true) => {
  const date = normalizeDate(value)
  if (!date || Number.isNaN(date.getTime())) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return withYear ? `${year}.${month}.${day}` : `${month}.${day}`
}

const getThresholdText = (coupon) => {
  if (coupon.thresholdText) return coupon.thresholdText
  const threshold = Number(coupon.thresholdAmount ?? coupon.threshold ?? coupon.fullAmount ?? 0)
  if (!threshold || coupon.couponType === 'NO_THRESHOLD') return '无门槛'
  return `满${threshold}减`
}

const getValidText = (coupon) => {
  if (coupon.validText) return coupon.validText
  const start = coupon.validStartTime || coupon.validStartAt || coupon.startTime
  const end = coupon.validEndTime || coupon.validEndAt || coupon.endTime
  const startText = formatDate(start)
  const endText = formatDate(end, false)
  if (!startText || !endText) return '有效期：长期有效'
  return `${startText} - ${endText}`
}

const formatCouponValue = (value, isRate = false) => {
  const number = Number(value ?? 0)
  const normalizedValue = isRate && number > 0 && number <= 1 ? number * 10 : number
  return Number.isInteger(normalizedValue)
    ? String(normalizedValue)
    : String(Number(normalizedValue.toFixed(2))).replace(/\.0+$/, '')
}

const normalizeCoupon = (coupon, index) => {
  const discountType = coupon.discountType
  const couponType = coupon.couponType
  const type = coupon.type === 'discount' || coupon.discount || discountType === 'RATE' || couponType === 'DISCOUNT' ? 'discount' : 'amount'
  const rawValue = type === 'discount'
    ? (coupon.discount ?? coupon.discountValue)
    : (coupon.amount ?? coupon.discountValue)

  return {
    ...coupon,
    id: coupon.id ?? coupon.userCouponId ?? coupon.couponId ?? `mobile-received-coupon-${index}`,
    type,
    displayValue: formatCouponValue(rawValue, type === 'discount'),
    name: coupon.name || coupon.title || '会员满减优惠券',
    scopeText: coupon.scopeText || coupon.description || coupon.applicableText || '购买年度会员页',
    thresholdText: getThresholdText(coupon),
    validText: getValidText(coupon)
  }
}

const receivedCoupons = computed(() => sourceCoupons.value.map(normalizeCoupon))
const couponCountText = computed(() => `${receivedCoupons.value.length}张`)
const couponListClass = computed(() => receivedCoupons.value.length === 1
  ? 'h-[73px] overflow-visible'
  : 'h-[186px] overflow-y-auto overflow-x-hidden [-ms-overflow-style:none] [-webkit-overflow-scrolling:touch] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
)

const ClockIcon = (_, { attrs }) => h(
  'svg',
  {
    ...attrs,
    viewBox: '0 0 12 12',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  [
    h('path', {
      d: 'M6 12C2.686 12 0 9.314 0 6S2.686 0 6 0s6 2.686 6 6-2.686 6-6 6Zm0-1.2A4.8 4.8 0 1 0 6 1.2a4.8 4.8 0 0 0 0 9.6Zm.6-4.8H9v1.2H5.4v-4h1.2V6Z',
      fill: 'currentColor'
    })
  ]
)

const isIOSNativeWebView = () => {
  const ua = navigator.userAgent || ''
  return /iPad|iPhone|iPod/i.test(ua) && !/Safari/i.test(ua)
}

const closeNativeView = () => {
  if (window.JsAndroid) {
    window.JsAndroid.closeView()
    return true
  }
  if (window.prompt && isIOSNativeWebView()) {
    window.prompt('ydppt://closeView')
    return true
  }
  return false
}

const closePage = () => {
  reportEvent('app_clicks', {
    ck_module: '首页_获得优惠券弹窗_关闭'
  })
  close()
  emit('close')
  if (props.modalMode) return
  if (closeNativeView()) return
  if (window.history.state?.back) {
    router.back()
  } else {
    router.push('/m/home')
  }
}

const openMyCouponWebview = () => {
  if (!window.JsAndroid && !window.prompt) return false
  const targetUrl = encodeURIComponent(`${window.location.origin}/m/my-coupon`)
  const webviewUrl = `ydppt://webview?url=${targetUrl}&title=`
  const closeCurrentPopupWebview = () => {
    window.setTimeout(() => {
      closeNativeView()
    }, 300)
  }

  if (window.JsAndroid) {
    window.location.href = webviewUrl
    closeCurrentPopupWebview()
    return true
  }

  window.location.href = webviewUrl
  closeCurrentPopupWebview()
  return true
}

const goMyCoupon = () => {
  reportEvent('app_clicks', {
    ck_module: '首页_获得优惠券弹窗_前往查看'
  })
  emit('view')
  close()
  if (openMyCouponWebview()) return
  router.push('/m/my-coupon')
}

const isSuccessResponse = (res) => ['SUCCESS', '0', 0, '200', 200].includes(res?.code)

const getResponseCoupons = (res) => {
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res?.data?.list)) return res.data.list
  return []
}

const getCouponPopupCacheKey = () => {
  const key = Array.isArray(route.query?.couponPopupKey)
    ? route.query.couponPopupKey[0]
    : route.query?.couponPopupKey
  return key ? `${COUPON_POPUP_CACHE_PREFIX}${key}` : ''
}

const readCachedPopupCoupons = () => {
  const storageKey = getCouponPopupCacheKey()
  if (!storageKey) return []

  try {
    const cache = JSON.parse(localStorage.getItem(storageKey) || '{}')
    localStorage.removeItem(storageKey)
    if (!Array.isArray(cache.coupons) || Date.now() > Number(cache.expiresAt || 0)) return []
    return cache.coupons
  } catch {
    localStorage.removeItem(storageKey)
    return []
  }
}

const cachePopupCoupons = (coupons) => {
  const popupKey = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
  try {
    localStorage.setItem(
      `${COUPON_POPUP_CACHE_PREFIX}${popupKey}`,
      JSON.stringify({
        coupons,
        expiresAt: Date.now() + COUPON_POPUP_CACHE_TTL
      })
    )
  } catch {}
  return popupKey
}

const openNativeCouponModal = (coupons) => {
  if (!window.JsAndroid && !window.prompt) return false
  const popupKey = cachePopupCoupons(coupons)
  const url = `${window.location.origin}/m/coupon-received?nativeModal=1&couponPopupKey=${encodeURIComponent(popupKey)}`
  const encodedUrl = encodeURIComponent(url)

  if (window.JsAndroid) {
    window.location.href = `ydppt://webful?url=${encodedUrl}&w=318&h=520&modal=true&dim=true&closeBtn=false`
    return true
  }

  window.location.href = `ydppt://webful?url=${encodedUrl}&w=318&h=520&modal=false&dim=true&closeBtn=false`
  return true
}

const fetchPopupCoupons = async () => {
  if (props.coupons?.length) return props.coupons
  const cachedCoupons = readCachedPopupCoupons()
  if (cachedCoupons.length) {
    apiCoupons.value = cachedCoupons
    return apiCoupons.value
  }
  if (!hasCouponPopupLogin()) {
    apiCoupons.value = []
    return apiCoupons.value
  }
  if (isLoadingCoupons.value) return apiCoupons.value

  const requestKey = latestRequestKey.value + 1
  latestRequestKey.value = requestKey
  isLoadingCoupons.value = true

  try {
    const res = await getCouponPopup()
    if (requestKey !== latestRequestKey.value) return apiCoupons.value
    apiCoupons.value = isSuccessResponse(res) ? getResponseCoupons(res) : []
  } catch {
    apiCoupons.value = []
  } finally {
    if (requestKey === latestRequestKey.value) {
      isLoadingCoupons.value = false
    }
  }

  return apiCoupons.value
}

const open = async ({ preferNative = false, shouldOpen = () => true } = {}) => {
  if (!shouldOpen()) return false
  if (isVisible.value) return true
  const coupons = await fetchPopupCoupons()
  if (!shouldOpen()) return false
  if (!coupons.length) return false
  if (preferNative && openNativeCouponModal(coupons)) return true
  isVisible.value = true
  await nextTick()
  reportEvent('window', {
    window_name: '首页_获得优惠券弹窗'
  })
  return true
}

const close = () => {
  isVisible.value = false
}

defineExpose({
  open,
  close
})

onMounted(() => {
  if (props.autoShow) {
    open()
  }
})
</script>
